import { RelayPageDataTable } from "@constellation-academy/epic-ui";
import React, { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { messageDispatchesTable_MessageDispatchFragment$key } from "@relay/messageDispatchesTable_MessageDispatchFragment.graphql";
import { messageDispatchesTable_QueryFragment$key } from "@relay/messageDispatchesTable_QueryFragment.graphql";
import { messageDispatchesTable_Refetch } from "@relay/messageDispatchesTable_Refetch.graphql";
import { ROWS_COUNT } from "./message-dispatches-table.const";
import { MESSAGE_DISPATCH_FRAGMENT, QUERY_FRAGMENT } from "./message-dispatches-table.graphql";
import { buttonWrapperClass } from "./message-dispatches-table.styles";
import { MessageDispatchesTableProps } from "./message-dispatches-table.types";
import { DateTimeDisplay } from "../../../../components/DateTimeDisplay";

import { DeleteMessageDispatchButton } from "../../../message-dispatches/delete-message-dispatch-button";
import { EditMessageDispatchButton } from "../../../message-dispatches/edit-message-dispatch-button";
import { MessageDispatchContext } from "../../../message-dispatches/message-dispatches.context";

export const MessageDispatchesTable = ({
	messageDispatchesFragmentRef,
}: MessageDispatchesTableProps) => {
	const { t } = useTranslation("common");
	const { setConnectionId } = useContext(MessageDispatchContext);

	const handleOnConnectionIdChange = (id?: string | null) => {
		id && setConnectionId(id);
	};

	return (
		<RelayPageDataTable<
			messageDispatchesTable_Refetch,
			messageDispatchesTable_QueryFragment$key,
			messageDispatchesTable_MessageDispatchFragment$key
		>
			queryFragment={QUERY_FRAGMENT}
			parentFragmentRef={messageDispatchesFragmentRef}
			nodeInlineFragment={MESSAGE_DISPATCH_FRAGMENT}
			extractConnection={(data) => data.Admin.Message.MessageDispatches}
			onConnectionIdChange={handleOnConnectionIdChange}
			rowsCount={ROWS_COUNT}
			emptyMessage={t("messageDispatch.tableEmpty")}
		>
			{(Column) => (
				<>
					<Column
						header={t("messageDispatch.tableUsedTemplate")}
						body={(item) => item.messageDefinition.internalTitle}
					/>
					<Column
						header={t("messageDispatch.tableCreatedBy")}
						body={(item) => item.createdBy.name}
					/>
					<Column
						header={t("messageDispatch.tableSendAt")}
						body={(item) => <DateTimeDisplay value={item.sendAt} hideTimezone />}
					/>
					<Column
						header={t("messageDispatch.tableDispatchedAt")}
						body={(item) => <DateTimeDisplay value={item.dispatchedAt} hideTimezone />}
					/>
					<Column
						header={t("table.actions")}
						style={{ width: "20%" }}
						body={(item) => (
							<div className={buttonWrapperClass}>
								<EditMessageDispatchButton messageDispatchFragmentRef={item} />
								<DeleteMessageDispatchButton messageDispatchFragmentRef={item} />
							</div>
						)}
					/>
				</>
			)}
		</RelayPageDataTable>
	);
};
